module.exports = __webpack_public_path__ + "static/img/character-3.09625de8.png";